export default function Announcements({ items }) {
  if (!items || items.length === 0) return null;

  return (
    <section
      id="announcements"
      data-testid="announcements-section"
      className="border-y border-[var(--rule)] bg-[var(--bg)]"
    >
      <div className="max-w-page container-x py-6 md:py-7">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-start">
          <div className="md:col-span-2">
            <span className="eyebrow eyebrow--accent">Latest</span>
          </div>
          <ul className="md:col-span-10 flex flex-col divide-y divide-[var(--rule-soft)]">
            {items.map((a, i) => (
              <li
                key={a.id}
                className="py-3 md:py-4 grid grid-cols-12 gap-4 items-baseline"
                data-testid={`announcement-item-${i}`}
              >
                <time className="col-span-3 md:col-span-2 text-[12px] text-[var(--fg-muted)] tabular-nums">
                  {a.date}
                </time>
                <div className="col-span-9 md:col-span-10">
                  <p
                    className="text-[15px] md:text-[16px] font-medium leading-snug tracking-[-0.005em]"
                    data-testid={`announcement-title-${i}`}
                  >
                    {a.title}
                  </p>
                  {a.body && (
                    <p
                      className="text-[13px] md:text-[14px] text-[var(--fg-muted)] mt-0.5 max-w-[70ch]"
                      data-testid={`announcement-body-${i}`}
                    >
                      {a.body}
                    </p>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
